import {IconSizeColorProps} from "./types";

export default function ArrowSendIcon({
                                          size=34,
                                          color="#6E6E6E",
                                          ...props
                                      }:IconSizeColorProps) {
    return <svg width={size} height={size} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M22.6567 11.313L11.343 22.6267M22.6567 11.313L22.6567 19.7982M22.6567 11.313L14.1714 11.313"
              stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

}